import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { INotificationsState } from './notifications.reducer';
import * as fromReducer from './notifications.reducer';

const getNotificationsState = createFeatureSelector<INotificationsState>('notifications');

export const getRegisterDeviceActionState = createSelector(
  getNotificationsState,
  fromReducer.getRegisterDeviceActionState
);

export const getSuccessfulTokenRegistration = createSelector(
  getNotificationsState,
  fromReducer.getSuccessfulTokenRegistration
);

export const getUnregisterDeviceActionState = createSelector(
  getNotificationsState,
  fromReducer.getUnregisterDeviceActionState
);
